import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Environment, ENVIRONMENT } from '../environment';

export const apiInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const env: Environment = inject(ENVIRONMENT);
  if (request.url.startsWith('api/')) {
    const url = `${env.apiUrl}${request.url}`;
    const apiRequest = request.clone({
      url: url,
    });
    return next(apiRequest);
  }
  return next(request);
};
